import { render, staticRenderFns } from "./teamMemberDetails.vue?vue&type=template&id=7a3835dc&scoped=true&"
import script from "./teamMemberDetails.vue?vue&type=script&lang=js&"
export * from "./teamMemberDetails.vue?vue&type=script&lang=js&"
import style0 from "./teamMemberDetails.vue?vue&type=style&index=0&id=7a3835dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3835dc",
  null
  
)

export default component.exports